
import { IFolderKPI, InboxFolderType } from "../models/inbox.models";
import { delay, Observable, of, switchMap } from "rxjs";
import { IAccount } from "../models/account.models";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { toHttpParams } from "../utils/http-params.util";
import { Injectable } from "@angular/core";
import { APIResponse } from "src/app/core/models/api-response";

@Injectable({ providedIn: 'root' })
export class InboxService {

    // ── Public properties ──────────────────────────────────────────────────────

    /** When true, methods return mock data instead of calling the API. */
    useMockData = environment.useMockData ?? false;

    // ── Constructor ────────────────────────────────────────────────────────────
    constructor(private http: HttpClient) { }


    // ── Account KPI ──────────────────────────────────────────────────────────
    getFoldersKPIs(accounts: IAccount[]): Observable<APIResponse<IFolderKPI>> {
        if (this.useMockData) {
            return of(null).pipe(delay(1000), switchMap(() => of<APIResponse<IFolderKPI>>({ data: [
                { id: InboxFolderType.ALL, name: 'All', total: 10, unread: 5 },
                { id: InboxFolderType.DRAFTS, name: 'Drafts', total: 2, unread: 0 },
                { id: InboxFolderType.SENT, name: 'Sent', total: 5, unread: 3 },
            ], object: undefined, message: 'Success', metadata: { page: 1, limit: 10, pages: 1, count: 3 } })));
        }
        return this.http.get<APIResponse<IFolderKPI>>(`${environment.BASE_URL_API}inbox/mailboxes/conversations`, { params: toHttpParams({ mailbox_ids: accounts.map((account) => account.id).join(',') }) });
    }

}